import React from 'react'
import clsx from 'clsx'
import Link from '@/atoms/Link/Link'

// assets
import { ReactComponent as PepperLogo } from 'public/assets/icons/WhitePepperLogo.svg'

/* styling */
import styles from './_.module.css'

interface Props {
  className?: string
  headerMenu: {
    title: string
    href: string
    className: string
  }[]
}

const SolsticeHeader: React.FC<Props> = ({ headerMenu, className }) => {
  return (
    <div
      className={clsx(
        className,
        'flex justify-between | p-6 lg:py-12 | max-width-container'
      )}
    >
      <Link href="/">
        <PepperLogo className="w-[169px] lg:w-[211px] | h-[32px] lg:h-[40px]" />
      </Link>
      <div
        className={clsx(
          styles.header__menu,
          styles.card,
          'flex justify-between | font-medium | invisible lg:visible'
        )}
      >
        {headerMenu.map((menu, key) => {
          return (
            <Link key={key} className={menu.className} href={menu.href}>
              {menu.title}
            </Link>
          )
        })}
        <div className={styles.gradientContainer}>
          <div className={clsx(styles.gradient, styles.gradient__1)} />
          <div className={clsx(styles.gradient, styles.gradient__2)} />
        </div>
      </div>
    </div>
  )
}

export default SolsticeHeader
